import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Prenota from "./Pages/Prenota";
import Regolamento from "./Pages/Regolamento";
import TariffeAbbonamenti from "./Pages/TariffeAbbonamenti";
import ContattiPage from "./Pages/ContattiPage";
import DaVittorioPage from "./Pages/DaVittorioPage";
import BarRistorantePage from "./Pages/BarRistorantePage";
import MenuPage from "./Pages/MenuPage";
import Riepilogo from "./Pages/Riepilogo";
import SuccessPage from "./Pages/SuccessPage";
import CancelPage from "./Pages/CancelPage";
import AdminLoginPage from "./Pages/AdminLoginPage";
import AdminPanel from "./Pages/AdminPanel";
import NotFoundPage from "./Pages/NotFoundPage"; // ✅ NEW IMPORT
import Abbonamento from "./Pages/Abbonamento";
import AbbonamentoSummaryPage from "./Pages/AbbonamentoSummaryPage";
import SuccessAbbonamentoPage from "./Pages/SuccessAbbonamentoPage";
import FailedAbbonamentoPage from "./Pages/FailedAbbonamentoPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/da-vittorio" element={<DaVittorioPage />} />
        <Route path="/prenota" element={<Prenota />} />
        <Route path="/regolamento" element={<Regolamento />} />
        <Route path="/tariffe" element={<TariffeAbbonamenti />} />
        <Route path="/abbonamento-premium" element={<Abbonamento />} />
        <Route path="/snack-bar" element={<BarRistorantePage />} />
        <Route path="/contatti" element={<ContattiPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/riepilogo" element={<Riepilogo />} />
        <Route path="/riepilogo-abbonamento" element={<AbbonamentoSummaryPage/>} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/success-abbonamento" element={<SuccessAbbonamentoPage />} />
        <Route path="/cancel" element={<CancelPage />} />
        <Route path="/fail-abbonamento" element={<FailedAbbonamentoPage />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />

        {/* Admin routes */}
        <Route path="/admin-panel" element={<AdminPanel />} />
        <Route path="/admin-servizio" element={<AdminPanel />} />
        <Route path="/admin-menu" element={<AdminPanel />} />
        <Route path="/admin-sconti" element={<AdminPanel />} />
        <Route path="/admin-posti" element={<AdminPanel />} />
        <Route path="/admin-abbonamenti" element={<AdminPanel />} />

        {/* ✅ Catch-all for invalid URLs */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;
